import { css } from "@emotion/react";

import { COLORS } from "../../stylesheets/emotion/vars";

export const roundabout69Style = css`
    body {
        overflow-y: hidden;
        scrollbar-width: none;
        -ms-overflow-style: none;

        &::-webkit-scrollbar {
            width: 0;
            height: 0;
        }
    }

    .bannerAll {
        display: grid;
        grid-template-columns: auto auto auto;
    }

    .bannerBack {
        width: 17.5%;
        margin-top: 0.55vw;
        position: absolute;
        margin-left: 53.6%;
    }

    .bannerFront {
        width: 19%;
        margin-left: 27.3%;
        margin-top: 0.68vw;
        position: absolute;
    }

    .bannerLogo {
        width: 4.2vw;
        position: relative;
        margin-top: 0.1vw;
        margin-left: 132.7%;
        z-index: 1000;
        filter: drop-shadow(0px 0px 5px #fff);
    }

    @keyframes rotation {
        0% {
            transform: rotate(0deg) scale(0.5);
            opacity: 0.4;
        }
        5% {
            transform: rotate(180deg) scale(0.5);
            opacity: 0.6;
        }
        10% {
            transform: rotate(360deg) scale(0.5);
            opacity: 0.4;
        }
        100% {
            transform: rotate(360deg) scale(0.5);
            opacity: 0.4;
        }
    }

    .menukaart {
        width: 98vw;
        height: 100vh;
        gap: 1vw;
        display: grid;
        padding-left: 0.5vw;
        padding-right: 0.5vw;
        margin-top: 1vh;
    }

    .menu {
        width: 100%;
        height: 45em;
        margin-top: 2vw;
    }

    .backgroundShadow {
        background-color: rgba(0, 0, 0, 0.6);
        border-radius: 15px;
    }

    .info {
        display: flex;
        flex-direction: row-reverse;
    }

    .row {
        display: flex;
        align-items: center;
        background-color: rgba(50, 50, 50, 0.1);
        height: 4em;
        padding-left: 0.5vw;
        padding-right: 1.5vw;
    }

    .row:nth-child(even) {
        background-color: rgba(0, 0, 0, 0.5);
    }

    .row:nth-last-child(1) {
        border-bottom-left-radius: 1vw;
        border-bottom-right-radius: 1vw;
    }

    .row:first-child {
        border-top-left-radius: 1vw;
        border-top-right-radius: 1vw;
    }

    .rowContent {
        display: flex;
        align-items: center;
    }

    .productkind {
        color: white;
        font-size: 0.9vw;
        margin-top: 0.3vw;
        width: 3vw;
        margin-left: 2vw;
    }

    .banner {
        width: 100%;
        margin-left: 8vw;
        margin-top: 1vw;
        position: relative;
    }

    .pagebackground {
        background-image: url("/images/pricelist/roundabout69_cannabis_blue.png");
        background-repeat: no-repeat;
        background-size: cover;
        width: 100%;
        height: 1920px;
    }

    .horecapagebackground {
        background-image: url("/images/pricelist/roundabout_blue_beans.png");
        background-repeat: no-repeat;
        background-size: cover;
        width: 100%;
        height: 1920px;
    }

    .redbg {
        position: absolute;
    }

    @font-face {
        font-family: "cordia";
        font-weight: normal;
        font-style: normal;
    }

    .logo {
        position: absolute;
        left: 20%;
        margin-top: 5vh;
        width: 60%;
        animation: rotation 25s 20s;
        animation-delay: 0s;
        animation-iteration-count: infinite;
        filter: drop-shadow(0px 0px 10px #fff);
    }

    .categoryImage {
        display: block;
        max-height: 60px;
        width: auto;
        min-width: 120px;
        object-fit: contain;
        margin: 1.5vh 0;
    }

    .marginTopTitle {
        margin-top: -4vw;
    }

    .title {
        margin-left: 0.6vw;
        font-size: 2.4vw;
        font-weight: 600;
        margin-top: 1.2vw;
        margin-bottom: 1vw;
        position: relative;
        width: 100%;
        color: white;
        text-shadow: 2px 2px #000000;
    }

    .titleNotAtTop {
        margin-left: 0.6vw;
        font-size: 2.4vw;
        font-weight: 600;
        margin-top: 1.2vw;
        margin-bottom: 1vw;
        position: relative;
        width: 20vw;
        color: white;
        text-shadow: 2px 2px #000000;
    }

    .particles {
        position: absolute;
        margin-left: 50vw;
        width: 300px;
    }

    .btn {
        position: absolute;
    }

    .kindBadge {
        height: 1vh;
        width: 1vw;
        margin-right: 1vw;
        margin-left: 0.25vw;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .nameStar {
        display: flex;
    }

    .newBadge {
    }

    .nameprice {
        font-size: 1.2em;
        text-transform: uppercase;
        color: white;
        font-weight: bold;
    }

    .description {
        font-size: 1em;
        color: ${COLORS.descriptionColor};
        margin: 0 auto;
    }

    .kind {
        font-size: 0.5vw;
        position: relative;
        margin-left: -2vw;
        margin-top: 0.5vw;
        width: 5vw;
        color: white;
    }

    .priceContainer {
        position: relative;
        right: 0.7vw;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .price {
        font-size: 1.2em;
        width: 5.5vw;
        color: white;
        text-align: right;
    }

    .priceHeader {
        position: relative;
        font-size: 1.2em;
        margin-top: -2vw;
        text-align: center;
        width: 5.5vw;
        color: white;
        font-weight: bold;
    }

    .filler {
        flex-grow: 1;
    }

    .svg-inline--fa {
        margin-left: 20px;
        margin-top: 8px;
        font-size: 30px;
    }

    .legendNew {
        display: none;
    }

    .priceGrid {
        display: flex;
        justify-content: center;
    }
`;
